import { Controller } from "@hotwired/stimulus";
import flatpickr from "flatpickr";

export default class extends Controller {
  static targets = ["dateInput", "timeInput"];

  connect() {
    if (this.hasDateInputTarget) {
      flatpickr(this.dateInputTarget, {
        dateFormat: "m/d/Y",
      });
    }

    if (this.hasTimeInputTarget) {
      flatpickr(this.timeInputTarget, {
        enableTime: true,
        noCalendar: true,
        time_24hr: false,
        dateFormat: "h:i K",
      });
    }
  }
}
